import useSWR, { SWRResponse } from 'swr';
import { Terrace } from '../../../providers/api/dtos/terrace';
import { getTerracesByPropertyId } from '../../../providers/api/terrace/terraceProvider';

export const TERRACES_RID = '/property/:id/terraces';

export default function useTerraces(propertyId?: number): SWRResponse<Terrace[], Error> {
  return useSWR(propertyId ? [TERRACES_RID, propertyId] : null, () => getTerracesByPropertyId(propertyId!));
}
